const shopCategories = [
  'Fashion and Apparel',
  'Beauty and Personal Care',
  'Food and Beverage',
  'Electronics and Gadgets',
  'Health and Wellness',
  'Financial Services',
  'Sports and Outdoor',
  'Home and Kitchen',
  'Real Estate and Property Management',
  'Software and SaaS',
  'Baby Products',
  'Digital Marketing Services',
  'Automotive',
  'Education',
  'Jewelry and Accessories',
  'Books and Education',
  'Toys and Games',
  'Pets and Pet Supplies',
  'Travel and Tourism',
  'Collectibles',
  'Other',
].sort();
export default shopCategories;
